import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useLanguage } from "@/i18n/LanguageContext";
import { Reveal } from "@/components/Reveal";

export const FAQ = () => {
  const { t } = useLanguage();
  const f = t.faq;

  return (
    <section id="faq" className="relative py-24 md:py-32">
      <div className="container-page">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <Reveal>
              <span className="overline text-[#CEA26B]">{f.overline}</span>
              <h2 className="mt-4 font-display font-bold tracking-tight text-white text-3xl sm:text-4xl lg:text-5xl leading-tight">
                {f.title}
              </h2>
            </Reveal>
          </div>

          <div className="lg:col-span-8">
            <Reveal>
              <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
                {f.items.map((item, i) => (
                  <AccordionItem
                    key={i}
                    value={`item-${i}`}
                    className="border-white/10"
                    data-testid={`faq-item-${i}`}
                  >
                    <AccordionTrigger className="text-left text-white font-display font-semibold text-base md:text-lg hover:no-underline hover:text-[#CEA26B] py-6">
                      {item.q}
                    </AccordionTrigger>
                    <AccordionContent className="text-slate-400 text-base leading-relaxed pb-6">
                      {item.a}
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
